module.exports = __webpack_public_path__ + "static/media/NYA.f850727e.png";